/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const Container = styled.div<{
  topOffset: number;
}>(props => ({
  display: 'flex',
  height: `calc(100vh - ${props.topOffset}px)`,
  position: 'sticky',
  justifyContent: 'flex-end',
  top: `${props.topOffset}px`,
}));
